export const IMAGES = {
  heroBg:
    "https://static.prod-images.emergentagent.com/jobs/1cda0ec1-717b-4976-b678-2213528a21e9/images/cd250630cf6b10f4104da0a57ad6bc3a9f4248b6f29cca18d1d6ca29b4b9ee17.jpeg",
  portrait:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_responsive-web-56/artifacts/3s6m33mw_2017-07-21%2023.29.18.webp",
  story:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_responsive-web-56/artifacts/u8j5ftlf_image.png",
  book:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_responsive-web-56/artifacts/6m27y4j3_IMG_8461.jpeg",
};

export const AMAZON_URL =
  "https://www.amazon.com/dp/B0HHXRMDC9";
